var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailInBlueBox(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 83,
    viewBox: "0 0 83 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.6109 3.17739C54.6229 -1.28884 75.2771 12.1241 79.7433 33.1361C84.2095 54.1481 70.7966 74.8022 49.7846 79.2685C28.7726 83.7347 8.11845 70.3217 3.65221 49.3098C-0.814021 28.2978 12.599 7.64362 33.6109 3.17739Z",
    fill: "url(#paint0_linear_53798_36084)",
    stroke: "white",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.3555 49.901C62.9812 50.2432 62.5136 50.4931 61.9817 50.6062L26.9838 58.0452C26.4519 58.1583 25.923 58.1201 25.4419 57.9598L34.6375 43.7999L38.1323 46.0695C39.4829 46.9466 41.0814 47.1871 42.884 46.804C44.6865 46.4208 46.049 45.5509 46.9261 44.2003L49.1957 40.7055L63.3555 49.901ZM64.1662 48.6528L50.0063 39.4573L59.2018 25.2974C59.544 25.6717 59.7939 26.1393 59.907 26.6712L64.2516 47.111C64.3646 47.6428 64.3265 48.1717 64.1662 48.6528ZM24.1937 57.1492C23.8516 56.7749 23.6016 56.3073 23.4886 55.7754L19.144 35.3357C19.0309 34.8038 19.069 34.2749 19.2294 33.7938L33.3892 42.9893L24.1937 57.1492ZM57.9536 24.4868L45.6779 43.3897C45.0264 44.3928 44.0071 45.0436 42.5745 45.3481C41.1419 45.6526 39.946 45.4727 38.9429 44.8213L20.04 32.5456C20.4143 32.2034 20.8819 31.9535 21.4138 31.8404L56.4117 24.4014C56.9436 24.2883 57.4725 24.3265 57.9536 24.4868Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_53798_36084",
    x1: -2.78755,
    y1: 12.9588,
    x2: 87.197,
    y2: 15.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.447115,
    stopColor: "#5D5FEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailInBlueBox);
export default __webpack_public_path__ + "static/media/emailInBlueBox.fed1a8daad0dde31fbcb6369df8d8201.svg";
export { ForwardRef as ReactComponent };